// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createAction, createActions } from 'redux-actions';

export const GET_SHIPPING_LABEL = 'GET_SHIPPING_LABEL';
export const GET_SHIPPING_LABEL_SUCCESS = 'GET_SHIPPING_LABEL_SUCCESS';

export const EMAIL_SHIPPING_LABEL = 'EMAIL_SHIPPING_LABEL';
export const EMAIL_SHIPPING_LABEL_SUCCESS = 'EMAIL_SHIPPING_LABEL_SUCCESS';

export const RESET_DEVICE_DATA = 'RESET_DEVICE_DATA';
export const REGENERATED_SHIPPING_LABEL = 'REGENERATED_SHIPPING_LABEL';
export const SHOW_ORDER_UPDATE_ALERT = 'SHOW_ORDER_UPDATE_ALERT';
export const HIDE_ORDER_UPDATE_ALERT = 'HIDE_ORDER_UPDATE_ALERT';
export const {
    emailShippingLabel,
    emailShippingLabelSuccess,
    showOrderUpdateAlert,
    hideOrderUpdateAlert,
} = createActions(
    EMAIL_SHIPPING_LABEL,
    EMAIL_SHIPPING_LABEL_SUCCESS,
    SHOW_ORDER_UPDATE_ALERT,
    HIDE_ORDER_UPDATE_ALERT
);
export const PUT_RECONCILE_SHIPPING_LABEL = 'PUT_RECONCILE_SHIPPING_LABEL';
export const PUT_RECONCILE_SHIPPING_LABEL_SUCCESS = 'PUT_RECONCILE_SHIPPING_LABEL_SUCCESS';
export const GET_RECONCILE_USERS = 'GET_RECONCILE_USERS';
export const GET_RECONCILE_USERS_SUCCESS = 'GET_RECONCILE_USERS_SUCCESS';
export const PUT_RECONCILE_SHIPPING_LABEL_FAILURE = 'PUT_RECONCILE_SHIPPING_LABEL_FAILURE';

export const {
    getShippingLabel,
    getShippingLabelSuccess,
} = createActions(
    GET_SHIPPING_LABEL,
    GET_SHIPPING_LABEL_SUCCESS
);

export const {
    putReconcileShippingLabel,
    putReconcileShippingLabelSuccess,
    putReconcileShippingLabelFailure,
} = createActions(
    PUT_RECONCILE_SHIPPING_LABEL,
    PUT_RECONCILE_SHIPPING_LABEL_SUCCESS,
    PUT_RECONCILE_SHIPPING_LABEL_FAILURE
);

export const {
    getReconcileUsers,
    getReconcileUsersSuccess,
} = createActions(
    GET_RECONCILE_USERS,
    GET_RECONCILE_USERS_SUCCESS
);

export const regenerateShippingLabel = createAction(REGENERATED_SHIPPING_LABEL);

export const resetDeviceData = createAction(RESET_DEVICE_DATA);